import React, { useEffect, useRef, useState } from 'react';

const AnimatedSection = ({ 
  children, 
  animation = 'fadeUp', 
  delay = 0, 
  duration = 700,
  threshold = 0.1,
  className = '' 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const currentRef = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold]);

  const animations = {
    fadeUp: {
      initial: 'opacity-0 translate-y-10',
      visible: 'opacity-100 translate-y-0'
    },
    fadeDown: {
      initial: 'opacity-0 -translate-y-10',
      visible: 'opacity-100 translate-y-0'
    },
    fadeLeft: {
      initial: 'opacity-0 translate-x-10',
      visible: 'opacity-100 translate-x-0'
    },
    fadeRight: {
      initial: 'opacity-0 -translate-x-10',
      visible: 'opacity-100 translate-x-0'
    },
    fadeIn: {
      initial: 'opacity-0',
      visible: 'opacity-100'
    },
    scaleUp: {
      initial: 'opacity-0 scale-95',
      visible: 'opacity-100 scale-100'
    },
    scaleDown: {
      initial: 'opacity-0 scale-105',
      visible: 'opacity-100 scale-100'
    },
    rotateIn: {
      initial: 'opacity-0 rotate-6',
      visible: 'opacity-100 rotate-0'
    },
    slideUp: {
      initial: 'opacity-0 translate-y-20',
      visible: 'opacity-100 translate-y-0'
    },
    slideLeft: {
      initial: 'opacity-0 translate-x-20',
      visible: 'opacity-100 translate-x-0'
    },
    slideRight: {
      initial: 'opacity-0 -translate-x-20',
      visible: 'opacity-100 translate-x-0'
    },
    bounce: {
      initial: 'opacity-0 translate-y-10 scale-95',
      visible: 'opacity-100 translate-y-0 scale-100'
    }
  };

  const animationConfig = animations[animation] || animations.fadeUp;

  return (
    <div
      ref={ref}
      className={`transition-all ${className} ${
        isVisible ? animationConfig.visible : animationConfig.initial
      }`}
      style={{ 
        transitionDuration: `${duration}ms`,
        transitionDelay: `${delay}ms`,
        transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)'
      }}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;
